import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

// Define a type for the slice state
interface UserSession {
  auth: boolean;
  sessionToken?: string;
  userSession?: {
    uid: string;
    sharedBoxID: string;
    iat: number;
    exp: number;
  };
}

const LStorage = window.localStorage;

// Define the initial state using that type
const initialState: UserSession = {
  auth: false,
};
const restoreSession = () => {
    try {
        const rawSession = LStorage.getItem('RAW_SESSION');
        if (rawSession) {
            const session = JSON.parse(rawSession);
            initialState.sessionToken = session.session_token;
            initialState.userSession = session.session;
        }
    } catch (e) {
      console.error(e);
        return {};
    }
};
restoreSession();

export const userSessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state, action: PayloadAction<any>)  => {
      state.sessionToken = (action.payload || {}).session_token || null;
      state.userSession = (action.payload || {}).session || null;
      try {
        LStorage.setItem('RAW_SESSION', JSON.stringify(action.payload));
      } catch (e) {
        console.error(e);
      }
    },
    setAuthStatus: (state, action: PayloadAction<any>)  => {
      state.auth = action.payload.isAuth;
    },
    resetSession: (state) => {
      delete state.sessionToken;
      delete state.userSession;
      LStorage.removeItem('RAW_SESSION');
    }
  },
})

export const { setAuthStatus, setSession, resetSession } = userSessionSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectUserSessionState = (state: RootState) => state.userSession;
export const selectIsAuth = (state: RootState) => state.userSession.auth;
export const selectSessionToken = (state: RootState) => state.userSession.sessionToken;
export const selectUserSession = (state: RootState) => state.userSession.userSession;

export default userSessionSlice.reducer;